function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/* eslint-disable react/no-string-refs */
import _get from 'lodash/get';
import _isNumber from 'lodash/isNumber';
import ReactModal from 'react-modal';
import React from 'react';
import PropTypes from 'prop-types';
ReactModal.defaultStyles.overlay.backgroundColor = 'rgba(0, 0, 0, 0.3)';
ReactModal.defaultStyles.overlay.zIndex = '9999999';
ReactModal.defaultStyles.content = {
  width: '500px',
  height: '336px',
  margin: '0 auto',
  position: 'absolute',
  top: '40px',
  left: '40px',
  right: '40px',
  bottom: '40px',
  border: '1px solid #ccc',
  background: '#fff',
  overflow: 'auto',
  WebkitOverflowScrolling: 'touch',
  borderRadius: '4px',
  outline: 'none',
  padding: '20px'
};

var Modal =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Modal, _React$Component);

  function Modal() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Modal)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {};

    _this._onContainerTouchMove = function (event) {
      var $modalViewScrollArea = $(event.target).closest('.modal-view-scroll-area');

      if (!$modalViewScrollArea.length) {
        event.preventDefault();
        event.stopPropagation();
      }
    };

    _this._onScrollAreaTouchMove = function (event) {
      event.stopPropagation();
      if (event.nativeEvent) event.nativeEvent.stopImmediatePropagation();

      var currentTouchScreenY = _this.getCurrentTouchScreenY(event);

      if (!_isNumber(currentTouchScreenY) || !_isNumber(_this.state.touchStartScreenY)) {
        return;
      }

      var scrollingUp = currentTouchScreenY < _this.state.touchStartScreenY;
      var currentScrollTop = _this.refs.modalViewScrollArea.scrollTop;
      var minTop = 0;
      var maxTop = _this.refs.modalViewScrollArea.scrollHeight - _this.refs.modalViewScrollArea.clientHeight;

      if (_this.refs.modalViewScrollArea.scrollHeight === _this.refs.modalViewScrollArea.clientHeight || !scrollingUp && currentScrollTop <= minTop || scrollingUp && currentScrollTop >= maxTop) {
        event.preventDefault();
      }
    };

    _this._onScrollAreaTouchStart = function (event) {
      _this.setState({
        touchStartScreenY: _this.getCurrentTouchScreenY(event)
      });
    };

    _this._onScrollAreaTouchEnd = function () {
      _this.setState({
        touchStartScreenY: null
      });
    };

    _this._onModalViewContainerClick = function (event) {
      if ($(event.target).closest('.modal-view').length) return;

      _this.props.handleHide();
    };

    _this.getCurrentTouchScreenY = function (event) {
      return _get(event, 'touches[0].screenY');
    };

    return _this;
  }

  _createClass(Modal, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          show = _this$props.show,
          handleHide = _this$props.handleHide,
          _this$props$shouldClo = _this$props.shouldCloseOnEsc,
          shouldCloseOnEsc = _this$props$shouldClo === void 0 ? true : _this$props$shouldClo,
          _this$props$shouldClo2 = _this$props.shouldCloseOnOverlayClick,
          shouldCloseOnOverlayClick = _this$props$shouldClo2 === void 0 ? true : _this$props$shouldClo2,
          classNames = _this$props.classNames;
      return React.createElement(ReactModal, {
        className: "modal-view-container modal-view-visible ".concat(classNames),
        isOpen: show,
        appElement: document.body,
        onRequestClose: handleHide,
        shouldCloseOnEsc: shouldCloseOnEsc,
        shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
        closeTimeoutMS: 200
      }, React.createElement("div", {
        className: this.props.body ? this.props.body : 'modal-view'
      }, this.props.children));
    }
  }]);

  return Modal;
}(React.Component);

Modal.propTypes = {
  show: PropTypes.bool.isRequired,
  shouldCloseOnEsc: PropTypes.bool,
  closeable: PropTypes.bool,
  body: PropTypes.string,
  shouldCloseOnOverlayClick: PropTypes.bool,
  handleHide: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  content: PropTypes.shape({
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    body: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    footer: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.node), PropTypes.node])
  }),
  classNames: PropTypes.string
};
export { Modal as default };